import ViewProfile from './ViewProfile';
export default ViewProfile;
